module.exports = __webpack_public_path__ + "img/Confirm-Package-th.73731e4.png";